import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=cbd93c08&scoped=true&"
import script from "./checkbox-group.vue?vue&type=script&lang=ts&"
export * from "./checkbox-group.vue?vue&type=script&lang=ts&"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=cbd93c08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd93c08",
  null
  
)

export default component.exports